import { render, staticRenderFns } from "./robikaBaseInfo.vue?vue&type=template&id=e4a3d3aa"
import script from "./robikaBaseInfo.vue?vue&type=script&lang=js"
export * from "./robikaBaseInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports